import CountryCell from '../CountryCell';

export function getRowId(row) {
	return row.country;
}

export const columns = [
	{
		field: 'country',
		headerName: 'País',
		headerClassName: 'header border-bottom border-right border-left',
		cellClassName: 'border-right border-left',

		minWidth: 90,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		renderCell: (params) => <CountryCell params={params} />,
		align: 'center',
	},
	{
		field: 'L1',
		headerName: 'L1',
		headerClassName: 'header border-bottom border-right',
		minWidth: 90,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'L2',
		headerName: 'L2',
		headerClassName: 'header border-bottom border-right',
		minWidth: 90,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'L3',
		headerName: 'L3',
		headerClassName: 'header border-bottom border-right',
		minWidth: 90,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'L4',
		headerName: 'L4',
		headerClassName: 'header border-bottom border-right',

		minWidth: 90,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'L5',
		headerName: 'L5',
		headerClassName: 'header border-bottom border-right',
		minWidth: 90,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'L6',
		headerName: 'L6',
		headerClassName: 'header border-bottom border-right',
		minWidth: 90,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'Total',
		headerName: '-',
		headerClassName: 'header border-bottom border-right',
		cellClassName: 'border-right',
		minWidth: 90,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
];

export const columnGroupingModel = [
	{
		groupId: 'Pais',
		headerName: '',
		description: '',
		headerClassName: 'header border-right border-bottom border-top border-left',
		cellClassName: 'border-right border-left',
		headerAlign: 'center',
		align: 'center',
		children: [{ field: 'country' }],
	},
	{
		groupId: 'Reserva',
		description: '',
		headerClassName: 'header border-right border-bottom border-top',
		headerAlign: 'center',
		align: 'center',
		children: [{ field: 'L1' }],
	},
	{
		groupId: 'Tránsito',
		description: '',
		headerClassName: 'header border-right border-bottom border-top',
		headerAlign: 'center',
		align: 'center',
		children: [{ field: 'L2' }],
	},
	{
		groupId: 'Clearence',
		description: '',
		headerClassName: 'header border-right border-bottom border-top',
		headerAlign: 'center',
		align: 'center',
		children: [{ field: 'L3' }],
	},
	{
		groupId: 'Inbound to WH o ZF',
		description: '',
		headerClassName: 'header border-right border-bottom border-top',
		headerAlign: 'center',
		align: 'center',
		children: [{ field: 'L4' }],
	},
	{
		groupId: 'Recepcion',
		description: '',
		headerClassName: 'header border-right border-bottom border-top',
		headerAlign: 'center',
		align: 'center',
		children: [{ field: 'L5' }],
	},
	{
		groupId: 'Outbound to FF',
		description: '',
		headerClassName: 'header border-right border-bottom border-top',
		headerAlign: 'center',
		align: 'center',
		children: [{ field: 'L6' }],
	},
	{
		groupId: 'Total de días',
		description: '',
		headerClassName: 'header border-right border-bottom border-top',
		headerAlign: 'center',
		align: 'center',
		children: [{ field: 'Total' }],
	},
];

export const tableStyles = {
	'& .MuiDataGrid-cell': {
		borderBottom: '1px solid #E0E0E0',
	},
	'& .border-left': {
		borderLeft: '1px solid #E0E0E0',
	},
	'& .border-top': {
		borderTop: '1px solid #E0E0E0',
	},
	'& .border-right': {
		borderRight: '1px solid #E0E0E0',
	},
	'& .border-bottom': {
		borderBottom: '1px solid #E0E0E0 !important',
	},
	'& .MuiDataGrid-columnHeaderRow:last-child': {
		borderBottom: '1px solid #E0E0E0',
	},

	'& .MuiDataGrid-columnHeader--emptyGroup': {
		borderBottom: '1px solid #E0E0E0',
	},
	'& .header': {
		backgroundColor: '#f3f4f6',
	},
	'& .header-special': {
		backgroundColor: '#e2e8f0',
	},
	'& .cell-special': {
		backgroundColor: '#f1f5f9',
	},
	'& .editable': {
		color: 'rgba(0, 0, 0, 0.38)',
	},
	'& .MuiDataGrid-scrollbar--vertical': {
		display: 'none',
	},
	'& .MuiDataGrid-filler': {
		height: 'fit-content !important',
	},
	'& .MuiDataGrid-main': {
		paddingBottom: '16px !important',
	},
	'& .no-padding': {
		padding: '0 !important',
	},
	'& .cell-cat': {
		backgroundColor: '#FFE0B2 !important',
	},
	'& .cell-hij': {
		backgroundColor: '#f9cfcf !important',
	},
	'& .triangle-top-left-cat': {
		width: '0',
		height: '0',
		borderBottom: '16px solid transparent',
		borderLeft: '16px solid orange',
	},
	'& .triangle-top-left-error': {
		width: '0',
		height: '0',
		borderBottom: '16px solid transparent',
		borderLeft: '16px solid red',
	},
	'& .triangle-bottom-left-error': {
		width: '0',
		height: '0',
		borderTop: '16px solid transparent',
		borderLeft: '16px solid red',
	},
	'& .MuiToolbar-root': {
		padding: '0 !important',
	},

	height: 'calc(100vh - 325px)',
	// height: '100%',
};
